export default __webpack_public_path__ + "static/media/login.20e0c7e8.jpg";